import { Fragment } from 'react'

export const renderStrikethrough = (children: JSX.Element[]) => (
  <Fragment>
    {children.map((child) => {
      if (child.props.className === 'strikethrough') {
        return <s>{child}</s>
      }
      return child
    })}
  </Fragment>
)
